export class FocusingInput {
  /**
   *
   * @param {HTMLElement|string} elements input/textarea elements or their selector
   */
  constructor(elements) {
    if (typeof elements === 'string' || elements instanceof String) {
      this.inputs = document.querySelectorAll(elements);
    } else {
      this.inputs = elements;
    }

    this.inputs.forEach((input) => {
      this.initElement(input);

      input.addEventListener('focus', this.focus);
      input.addEventListener('blur', this.blur);
    });
  }

  destroy() {
    this.inputs.forEach((input) => {
      input.removeEventListener('focus', this.focus);
      input.removeEventListener('blur', this.blur);
      input.removeEventListener('blur', this.onInput);
    });
  }

  initElement(input) {
    if (input.value.length > 0 || input === document.activeElement) {
      input?.parentElement?.classList.add('is-focused');
    } else {
      input?.parentElement?.classList.remove('is-focused');
    }
  }

  focus(event) {
    const input = event.target;
    input?.parentElement?.classList.add('is-focused');
  }

  blur(event) {
    const input = event.target;
    if (input.value.length === 0) {
      input?.parentElement?.classList.remove('is-focused');
    }
  }
}
